const t = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Is Null Icon</title><desc>A picture showing an empty circle.</desc><path d="M12 4.5a7.5 7.5 0 107.5 7.5A7.5 7.5 0 0012 4.5zm0 13a5.5 5.5 0 115.5-5.5 5.5 5.5 0 01-5.5 5.5z"/></svg>';
export {
  t as default
};
